<div mat-dialog-title>
    {{'Driving license'| translate}}
    <span class="float-right pointer" (click)="close()">
        <i class="fa fa-times close-btn "></i>
    </span>
    <!-- <span style="float: right;" (click)="close()" ><mat-icon>close</mat-icon>  </span> -->


</div>
<div mat-dialog-content class="">

    <form [formGroup]="drivingLicenseForm">
        <div class="row">

            <div class="col-md-3" *ngIf="field_config_access && field_config_access['RES-DL_countryId']">
                <tm-select [options]="master_data.countryList||[]" [form_group]="drivingLicenseForm"
                    form_control="countryId"
                    [label]="  field_config_access['RES-DL_countryId'].label ||'Country' |translate"
                    title_property="countryName" id_property="countryId" float_label="always"
                    [data]="drivingLicenseForm.value.countryId"
                    [placeholder]=" field_config_access['RES-DL_countryId'].placeholder || '<- -Select- ->' | translate">
                </tm-select>
            </div>

            <div class="col-md-3" *ngIf=" field_config_access &&field_config_access['RES-DL_licenseType']">

                <tm-select [options]="master_data.vehicleMasterList||[]" [form_group]="drivingLicenseForm"
                    form_control="licenseType"
                    [label]="  field_config_access['RES-DL_licenseType'].label ||'Country' |translate"
                    title_property="title" id_property="id" float_label="always"
                    [data]="drivingLicenseForm.value.licenseType"
                    [placeholder]=" field_config_access['RES-DL_licenseType'].placeholder || '<- -Select- ->' | translate">
                </tm-select>
                <!-- <mat-form-field floatLabel="always" class="tm-radio-group">
                    <mat-label> {{field_config_access['RES-DL_licenseType'].label || 'License type' }} </mat-label>
                    <input matInput class="d-none">
                    <mat-radio-group formControlName="licenseType">
                        <mat-radio-button [value]="1"> Heavy </mat-radio-button>
                        <mat-radio-button [value]="2"> Light </mat-radio-button>
                    </mat-radio-group>
                </mat-form-field> -->
            </div>

            <div class="col-md-3" *ngIf=" field_config_access &&field_config_access['RES-DL_vehicleName']">
                <mat-form-field floatLabel='always'>
                    <mat-label> {{field_config_access['RES-DL_vehicleName'].label ||'Vehicle name'}}
                    </mat-label>
                    <input matInput formControlName="vehicleName"
                        [placeholder]="field_config_access['RES-DL_vehicleName'].placeholder ||'Enter Employer/Project'">
                    <mat-error
                        *ngIf="drivingLicenseForm.controls.vehicleName.touched &&  drivingLicenseForm.controls.vehicleName.hasError('required')">
                        {{'ERROR.field_is_mandatory'|translate}}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-3" *ngIf="field_config_access && field_config_access['RES-DL_issueDate']">
                <tm-date-picker [form]="drivingLicenseForm" [controlName]="'issueDate'" [maxValue]="today"
                    [value]="drivingLicenseForm.value.issueDate" [placeholder]="drivingLicenseForm.value.issueDate"
                    [label]=" field_config_access['RES-DL_issueDate'].label || 'Issue date'"></tm-date-picker>
            </div>
            <div class="col-md-3" *ngIf="field_config_access && field_config_access['RES-DL_expiryDate']">
                <tm-date-picker [form]="drivingLicenseForm" [controlName]="'expiryDate'"
                    [minValue]="drivingLicenseForm.value.issueDate" [value]="drivingLicenseForm.value.expiryDate"
                    [placeholder]="drivingLicenseForm.value.expiryDate"
                    [label]=" field_config_access['RES-DL_expiryDate'].label || 'Expiry date'"></tm-date-picker>
            </div>

            <div class="col-md-4" *ngIf=" field_config_access &&field_config_access['RES-DL_attachments']">
                <tm-files-v2 [form_group]="drivingLicenseForm" [form_control]="'attachments'"
                    (validStatus)="uploadedStatus($event)"
                    [label]="field_config_access['RES-DL_attachments'].label ||'Attachments'|translate"
                    [result]="drivingLicenseForm.value.attachments"></tm-files-v2>
            </div>
            <!-- <div class="col-md-6" *ngIf=" field_config_access &&field_config_access['RES-DL_notes']">
                <mat-form-field floatLabel="always">
                    <mat-label>{{field_config_access['RES-DL_notes'].label ||'Notes'}}</mat-label>
                    <input matInput formControlName="notes"
                        [placeholder]="field_config_access['RES-DL_notes'].placeholder||'Enter notes'|translate">
                </mat-form-field>
            </div> -->
            <div class="col-md-2 text-right " *ngIf="id!=1">
                <button (click)="addExperience()" class="btn btn-sm  js-btn-save">
                    <i class="fa fa-plus-square mx-1"></i>
                    {{'BTN.add'|translate}}
                </button>
            </div>

            <div *ngIf="id!=1" class="col-md-12 table-responsive tm-data-table  "
                style="height: calc(100vh - 400px);overflow: auto;">
                <table class="table table-striped" *ngIf="field_config_access">
                    <thead>
                        <tr>
                            <th *ngIf="field_config_access['RES-DL_countryId']">
                                {{
                                field_config_access['RES-DL_countryId'].label ||'Country'}}
                            </th>
                            <th *ngIf="field_config_access['RES-DL_licenseType']">
                                {{
                                field_config_access['RES-DL_licenseType'].label ||'License type' | translate}}
                            </th>
                            <th *ngIf="field_config_access['RES-DL_issueDate']">
                                {{field_config_access['RES-DL_issueDate'].label ||'Issue date'}}
                            </th>
                            <th *ngIf=" field_config_access['RES-DL_expiryDate']">
                                {{
                                field_config_access['RES-DL_expiryDate'].label ||'Expiry dateF'}}
                            </th>


                            <th *ngIf="field_config_access['RES-DL_attachments']">
                                {{
                                field_config_access['RES-DL_attachments'].label ||'Attachments'|translate}}
                            </th>
                            <!-- <th *ngIf="field_config_access['RES-DL_notes']">
                                {{
                                field_config_access['RES-DL_notes'].label ||'Notes'}}
                            </th> -->
                            <th>
                                Action
                            </th>
                        </tr>

                    </thead>
                    <tbody>
                        <tr *ngFor="let item of exp_list;let i = index">
                            <td *ngIf="field_config_access['RES-DL_countryId']"> {{item.countryId |DynamicPipe :
                                master_data.countryList : 'countryId' : 'countryName' }} </td>
                            <td *ngIf="field_config_access['RES-DL_licenseType']"> {{
                                item.licenseType|DynamicPipe : master_data.vehicleMasterList : 'id':'title' }} </td>
                            <td *ngIf="field_config_access['RES-DL_issueDate']  "> {{item.issueDate |
                                date :"dd-MMM-yyyy"}}
                            </td>
                            <td *ngIf=" field_config_access['RES-DL_expiryDate'] ">
                                {{item.expiryDate | date :"dd-MMM-yyyy"}} </td>

                            <td *ngIf="field_config_access['RES-DL_attachments']" class="link"
                                (click)="viewAttachments(item.attachments)"> {{item.attachments &&
                                item.attachments.length?'View':''}} </td>
                            <!-- <td *ngIf="field_config_access['RES-DL_notes']">
                                {{item.notes}}
                            </td> -->
                            <td>
                                <button class="btn btn-sm btn-default mx-1 " (click)="editExperience(i)">
                                    <i class="fa fa-pencil mx-1"></i>
                                    {{'BTN.edit'|translate}}
                                </button>
                                <button class="btn btn-sm btn-default mx-1 " (click)="deleteExperience(i)">
                                    <i class="fa fa-trash orange mx-1"></i>
                                    {{'BTN.delete'|translate}}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </form>
</div>
<mat-dialog-actions *ngIf="id!=1">
    <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>

    <button style="min-width: 100px;" class="ml-auto  blob-btn-cancel btn mx-1 mx-1 tallite-action" (click)="close()">
        {{ 'BTN.cancel' | translate}}
        <span class="blob-btn-cancel__inner">
            <span class="blob-btn-cancel__blobs">
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
            </span>
        </span>
    </button>
    <button style="min-width: 100px;" class="blob-btn  btn   mx-1 tallite-action" type="submit" (click)="save()">
        {{ 'BTN.ok' | translate }}
        <span class="blob-btn__inner">
            <span class="blob-btn__blobs">
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
            </span>
        </span>
    </button>
</mat-dialog-actions>